import "./index.scss";

import React from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { EditorState, ContentState, convertFromRaw, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import Emoji from "./Actions/Emoji/Emoji";
import Inline from "./Inline/Inline";
import List from "./List/List";
import Actions from "./Actions/Actions";
import Uploader from "./Actions/Uploader/Uploader.js";
import Axios from "Source/axiosPool";
import { showToast } from '@/src/globalFunction';
import { queryClient } from '@/src/lib/react-query/react-query';
import { ACCEPT_ATTRIBUTE } from '@/src/config/fileTypes';

let members = []
let allMembers = []
@connect(store => {
    return {
        conversations: store.conversations,
        conversation: store.conversation,
        project: store.project,
        loggedUser: store.loggedUser,
        notes: store.notes,
    }
})

class TextEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            contentState: null,
            editorState: EditorState.createEmpty(),
        };
        this.initMembers = this.initMembers.bind(this)
    }

    componentWillUnmount() {
        $(".text-editor-inner-container").removeClass("uploaderActive");
    }

    componentDidMount() {
        const { project, loggedUser, message, dispatch } = this.props
        const content = { "entityMap": {}, "blocks": [] };
        const contentState = convertFromRaw((message && Object.keys(message).length > 0 && message.comment) ? JSON.parse(message.comment) : content);
        const editorState = EditorState.createWithContent(contentState);

        this.setState({
            ...this.state,
            editorState
        });
        this.initMembers(project, loggedUser)
        if (message && Object.keys(message).length > 0) {
            dispatch({ type: "UPDATE_CONVERSATIONS_FIELD_EDIT", field: "message", value: message.comment });
        }
    }

    shouldComponentUpdate(nextProps) {
        const { dispatch } = this.props;
        if (!_.isEqual(nextProps.conversations.actionType, this.props.conversations.actionType) && nextProps.conversations.actionType === "formSubmit") {
            const editorState = EditorState.createWithContent(ContentState.createFromText(''));
            this.setState({
                ...this.state,
                editorState
            }, () => {
                dispatch({ type: "UPDATE_CONVERSATIONS_ACTION_TYPE", action: null });
            });
        }
        if (!_.isEqual(nextProps.conversations.selected.id, this.props.conversations.selected.id)) {
            this.setState({
                contentState: null,
                editorState: EditorState.createEmpty(),
            }, () => {
                dispatch({ type: "UPDATE_CONVERSATIONS_ACTION_TYPE", action: null });
            });
        }
        // handle populate mention list
        if (!_.isEqual(nextProps.project.Selected.members, this.props.project.Selected.members)) {
            this.initMembers(nextProps.project, nextProps.loggedUser)
        }
        //handle reset editor
        if (!_.isEqual(nextProps.conversations.fields.message, this.props.conversations.fields.message) && typeof nextProps.conversations.fields.message === 'object') {
            const editorState = EditorState.createWithContent(ContentState.createFromText(''));
            this.setState({
                ...this.state,
                editorState
            }, () => {
                dispatch({ type: "UPDATE_CONVERSATIONS_ACTION_TYPE", action: null });
            });
        }
        return true;
    }
    initMembers(project, loggedUser) {
        const projectMembers = project.Selected.members ? project.Selected.members.filter(f => f.status === 'enabled') : []
        members = projectMembers.filter(m => m.id !== loggedUser.data.id).map(u => {
            return {
                text: `${u.user['first-name']} ${u.user['last-name']}`,
                value: `${u.user['first-name']} ${u.user['last-name']}`,
                url: u.id,
                userId: u.id
            }
        })
        allMembers = members
    }

    render() {
        const { dispatch, conversations, project, actionType, message } = this.props;
        const onEditorStateChange = (editorState) => {
            this.setState({
                editorState,
            }, () => {
                setTimeout(() => {
                    if ($("#view-conversation-form").length > 0) {
                        var parentOffset = $("#view-conversation-form").offset();

                        if ($("#view-conversation-form .rdw-suggestion-dropdown").length > 0) {
                            $("#view-conversation-form .rdw-suggestion-dropdown").css({
                                "top": $(".rdw-suggestion-dropdown").parent().offset().top - (parentOffset.top - 25),
                                "left": $(".rdw-suggestion-dropdown").parent().offset().left - (parentOffset.left - 769),
                                "position": "fixed",
                                "display": "flex"
                            });
                        }
                    }
                }, 50);
            });

        };
        const parseMention = (message) => {
            const obj = IsJsonString(message) ? JSON.parse(message) : message;
            const mention = Object.keys(obj.entityMap)
                .map(o => obj.entityMap[o])
                .filter(f => f.type === 'MENTION')
                .map(m => m.data)
            return mention
        };

        const onChange = e => {
            if (actionType === 'send') {
                $('.rdw-suggestion-dropdown').css({ "left": "60px", "width": "200px" })

            } else {
                $('.rdw-suggestion-dropdown').css({ "width": "200px" })
            }
            const tag = parseMention(e)
            if (tag.length > 0) {
                members = members.filter(m => tag.map(e => e.url).indexOf(m.url) < 0)
            } else {
                members = allMembers
            }

            if (actionType === 'edit') {
                dispatch({ type: "UPDATE_CONVERSATIONS_FIELD_EDIT", field: "message", value: JSON.stringify(e) });
            } else {
                dispatch({ type: "UPDATE_CONVERSATIONS_FIELD", field: "message", value: JSON.stringify(e) });
            }
        }

        const IsJsonString = (str) => {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }

            return true;
        }

        const handleClickSend = () => {
            const { dispatch } = this.props;

            dispatch({ type: 'SET_SCREEN_LOADER', Loading: true });
            $('#conversation-upload').trigger('click');
        }

        const sendMessage = () => {
            const { dispatch, conversations, project, conversation, notes } = this.props;
            const isCreateConversation = Object.keys(conversations.selected).length === 0;

            if (isCreateConversation) {
                const fields = conversations.fields;

                let mentionIds = [];
                if (IsJsonString(fields.message)) {
                    mentionIds = parseMention(fields.message).map((u) => u.url);
                }
                const params = {
                    title: fields.subject,
                    message: typeof fields.message === 'string' ? fields.message : '',
                    projectId: project.Selected.id,
                    documentIds: conversations.forUpload.map((f) => f.id),
                    workstreamIds: fields.workstreams,
                    mentionedUsers: mentionIds,
                    users: fields.to,
                };

                Axios.post('api/conversation/createConversation', params)
                    .then((response) => {
                        const selectedNote = response.data[0];
                        const { note, id, tagged_workstreams_notes, tagged_users, comments, projectId } =
                            selectedNote;
                        const { List } = notes;

                        dispatch({
                            type: 'SET_NOTES_SELECTED',
                            Selected: {
                                title: note,
                                id,
                                workstream: tagged_workstreams_notes,
                                users: _.map(
                                    tagged_users.filter((t) => t.user),
                                    ({ user }) => {
                                        return {
                                            value: user.id,
                                            label: user.firstName + ' ' + user.lastName,
                                            avatar: user.avatar,
                                        };
                                    }
                                ),
                                tagged_users,
                                message: '',
                            },
                        });
                        dispatch({ type: 'SET_NOTES_LIST', list: [...response.data, ...List] });
                        dispatch({
                            type: 'SET_COMMENT_LIST',
                            list: comments,
                            count: { total_count: 1, current_page: 1, last_page: 1 },
                        });
                        dispatch({ type: 'CLEAR_CONVERSATIONS_FIELDS' });
                        dispatch({ type: 'UPDATE_CONVERSATIONS_SELECTED', selected: selectedNote });
                        dispatch({ type: 'UPDATE_CONVERSATIONS_ACTION_TYPE', action: 'formSubmit' });
                        dispatch({ type: 'SET_NOTES_TYPE', note: 'inbox' });
                        Axios.get(
                            `api/conversation/getConversationListV2?linkType=notes&linkId=${id}&projectId=${projectId}`
                        ).then((response) => {
                            if (response) {
                                dispatch({ type: 'CONVERSATION_UPLOADED_FILE', files: [] });
                                dispatch({ type: 'CONVERSATION_FILE_INSERTED', bool: false });
                                dispatch({
                                    type: 'UPDATE_CONVERSATIONS_SELECTED_MESSAGES',
                                    messages: response.data.result.reverse(),
                                });
                                dispatch({ type: 'UPDATE_CONVERSATIONS_SELECTED_EVENTS', events: response.data.event });
                                dispatch({ type: 'CONVERSATION_TOBE_CLEAR' });
                                $('#create-conversation-form').modal('hide');
                                $(".text-editor-inner-container").removeClass("uploaderActive");
                                $('#view-conversation-form').modal('show');

                                showToast('success', 'Message sent!');

                                $('.insert_upload').remove();
                                $('.conversation-modal .conversation-list.hasScroll').css(
                                    'max-height',
                                    'calc(100vh - 500px)'
                                );
                            }
                            queryClient.invalidateQueries(['conversations']);
                            dispatch({ type: 'SET_SCREEN_LOADER', Loading: false });
                        });
                    })
                    .catch(() => {
                        dispatch({ type: 'SET_SCREEN_LOADER', Loading: false });
                        showToast('error', 'Unable to send message. Please try again');
                    });
            } else {
                const fields = conversations.fields;
                const groupId = conversations.selectedMsg ? conversations.selectedMsg.id : null;
                let mentionId = [];
                if (IsJsonString(fields.message)) {
                    mentionId = parseMention(fields.message).map((u) => u.url);
                }
                const params = {
                    comment: typeof fields.message === 'string' ? fields.message : '',
                    projectId: project.Selected.id,
                    documentIds: conversations.forUpload.map((f) => f.id),
                    workstreamIds: conversations.selected.tagged_workstreams_notes.map((w) => w.workstream.id),
                    mentionedUsers: mentionId,
                    users: conversations.selected.tagged_users.map((w) => w.user.id),
                    linkId: conversations.selected.id,
                    commentGroup: groupId,
                };

                Axios.post('api/conversation/sendMessage', params)
                    .then((response) => {
                        if (response) {
                            // dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_MESSAGES", messages: [...conversations.selectedMessages, response.data] });
                            dispatch({ type: 'UPDATE_CONVERSATIONS_ACTION_TYPE', action: 'formSubmit' });
                            dispatch({ type: 'CLEAR_CONVERSATIONS_FIELDS' });
                        }
                        const docs = [...response.data.conversationDocuments, ...conversations.selected.notesTagDoc];
                        dispatch({ type: 'CONVERSATION_UPLOADED_FILE', files: [] });
                        dispatch({ type: 'CONVERSATION_FILE_INSERTED', bool: false });
                        dispatch({
                            type: 'UPDATE_CONVERSATIONS_SELECTED',
                            selected: {
                                ...conversations.selected,
                                notesTagDoc: docs,
                                unread: 0,
                                total_count: conversations.selected.total_count + 1,
                            },
                        });
                        dispatch({ type: 'CONVERSATION_TOBE_CLEAR' });
                        dispatch({ type: 'SET_SCREEN_LOADER', Loading: false });
                        dispatch({ type: 'SET_CONVERSATIONS_MSG_SELECTED', selected: {} });
                        $('.insert_upload').remove();
                        $('.conversation-modal .conversation-list.hasScroll').css(
                            'max-height',
                            'calc(100vh - 500px)'
                        );
                        setTimeout(() => {
                            const ht = $('#divElement').prop('scrollHeight');
                            $('#divElement').animate(
                                {
                                    scrollTop: ht + 500,
                                },
                                2000
                            );
                        }, 100);
                        $('.conversation-message').removeClass('active');
                        if (conversations.latestMessages.length > 0) {
                            dispatch({
                                type: 'UPDATE_CONVERSATIONS_SELECTED_MESSAGES',
                                messages: [...conversations.latestMessages, response.data],
                            });
                            dispatch({ type: 'SET_CONVERSATIONS_LATEST', list: [] });
                        }
                        Axios.post(`api/conversation/seen`, {
                            noteId: conversations.selected.id,
                            projectId: project.Selected.id,
                            //conversationIds: response.data.result.map(c=>c.id)
                        }).then((result) => {
                            if (result.data) {
                                const count = conversation.ConversationCount;
                                dispatch({ type: 'SET_CONVERSATION_COUNT', count: count < 1 ? 0 : count - 1 });
                            }
                        });
                    })
                    .catch(() => {
                        showToast('error', 'Unable to send message. Please try again');
                        dispatch({ type: 'SET_SCREEN_LOADER', Loading: false });
                    });
            }
        }

        const CompActions = props => {
            return <Actions {...props}
                actionType={this.props.actionType}
                onAction={() => {
                    this.setState({
                        contentState: null,
                        editorState: EditorState.createEmpty(),
                    });
                    handleClickSend();
                }} />
        }
        const handleUpload = (file) => {
            dispatch({ type: "CONVERSATION_TOBE_UPLOAD", files: file, isAdd: true });

        }
        const handleDelete = (file) => {
            dispatch({ type: "CONVERSATION_TOBE_UPLOAD", files: file, isAdd: false });

        }
        const type = Object.keys(conversations.selected).length === 0 ? 'submit' : 'send'
        const Upload = () => {
            return <Uploader accept={ACCEPT_ATTRIBUTE}
                url={'/api/conversation/upload'}
                maxFiles={1000}
                // auto
                hide
                onUpload={handleUpload}
                id={"conversation"}
                section={'conversation'}
                actionType={type}
                onDelete={handleDelete}
                onFinishUpload={sendMessage}
            />
        }
        const update = () => {
            const fields = conversations.fieldsEdit;
            const params = {
                comment: typeof fields.message === 'string' ? fields.message : "",
                isEdit: 1,
                type: 'conversation'
            }
            Axios.put(`api/conversation/updateConversation/${message.id}`, params)
                .then(res => {
                    const selectedMessage = conversations.selectedMessages
                    dispatch({
                        type: "UPDATE_CONVERSATIONS_SELECTED_MESSAGES", messages: selectedMessage.map(s => {
                            delete s.forEdit
                            return s
                        })
                    })
                })
        }
        const onCancel = () => {
            const fields = conversations.fieldsEdit;
            if (message.comment && fields.message && (message.comment !== fields.message)
                || message.comment.length !== (fields.message ? isMessageEmpty(fields.message) : 0)) {
                $('#cancelEdit').modal('show')
            } else {
                const selectedMessage = conversations.selectedMessages
                dispatch({
                    type: "UPDATE_CONVERSATIONS_SELECTED_MESSAGES", messages: selectedMessage.map(s => {
                        delete s.forEdit
                        return s
                    })
                })
            }
        }
        const isMessageEmpty = (message) => {
            const obj = JSON.parse(message)
            if (obj.blocks.length === 1 && !obj.blocks[0].text) {
                return 0
            }
            return message.length
        }
        let option = ["inline", "list", "fontSize", "emoji", "blockType"]

        let toolBar = {
            inline: {
                component: Inline
            },
            list: {
                component: List
            },
            fontSize: {
                component: CompActions
            },
            emoji: {
                component: Emoji
            },
            blockType: {
                component: Upload
            }
        }
        if (actionType === 'edit') {
            option = ["inline", "list", "emoji"]
            toolBar = {
                inline: {
                    component: Inline
                },
                list: {
                    component: List
                },

                emoji: {
                    component: Emoji
                }

            }
        }
        const optionsToolbar = {
            options: option,
            ...toolBar

        }
        const blocks = convertToRaw(this.state.editorState.getCurrentContent()).blocks;
        const mesasgeParse = message ? JSON.parse(message.comment).blocks : []
        const oldmsg = mesasgeParse.map(block => (!block.text.trim() && '\n') || block.text).join('\n')
        const currentmsg = blocks.map(block => (!block.text.trim() && '\n') || block.text).join('\n');
        const onEdit = this.props.actionType === "edit"

        const currentLen = JSON.stringify(convertToRaw(this.state.editorState.getCurrentContent())).length
        const msgLen = (message ? message.comment : '').length
        const hasMessageEdit = currentmsg.trim().length > 0 && (oldmsg !== currentmsg || (msgLen !== 0 && currentLen !== msgLen))
        const isReply = Object.keys(conversations.selectedMsg).length > 0; 
        return (
            <div class={`text-editor-container ${this.props.classes ? this.props.classes : ""} ${onEdit ? "editMessage" : ""} ${isReply ? 'activeReply' : ''}`}>
                <Editor
                    editorState={this.state.editorState}
                    wrapperClassName="text-editor-wrapper"
                    editorClassName="text-editor-inner-container"
                    toolbarClassName="text-editor-toolbar"
                    onEditorStateChange={onEditorStateChange}
                    onChange={onChange}
                    stripPastedStyles={true}
                    placeholder={'Add your message here...'}
                    toolbar={optionsToolbar}
                    mention={{
                        separator: ' ',
                        trigger: '@',
                        suggestions: members
                    }}
                />
                {onEdit &&
                    <div class="action-buttons">
                        <a class={`btnCancel `} onClick={onCancel} >Cancel</a>
                        <a class={`sendBtn ${hasMessageEdit ? 'active' : ''}`} onClick={update}>Save</a>
                    </div>
                }
            </div>
        );
    }
}

export default TextEditor;